import { commonMetaData } from '~/store/_helpers/common-helper'
import grpcClient from '@/grpc/grpc-client'

const VERIFY_TYPE_PRIVATE = 1
const VERIFY_TYPE_BUSINESS = 2

// initial state
export const state = () => ({
  email: null,
  privateAccount: null,
  businessAccount: null,
  isEmailExpired: false,
  isAccountExpired: false,
  isRegistered: false,
  isPrivateVerification: false,
  isSessionKeyRequiredToResendEmail: false
})

// getters
export const getters = {}

// actions
export const actions = {
  async requestEmailVerification(
    { commit, rootState },
    { email, sessionKey = null, invitationKey = null, verifyType = VERIFY_TYPE_BUSINESS }
  ) {
    if (![VERIFY_TYPE_PRIVATE, VERIFY_TYPE_BUSINESS].includes(verifyType)) {
      throw new Error(`Unacceptable verifyType: ${verifyType}`)
    }
    const requestModule = await import('~/stub/apigateway/business/business_email_verification_pb')
    const methodModule = await import('~/stub/apigateway/business/business_email_verification_pb_service')
    const metadata = commonMetaData(rootState)
    const request = new requestModule.AddVerifyRequestRequest()
    request.setVerifyType(verifyType)
    request.setEmail(email)
    if (sessionKey) {
      request.setSessionKey(sessionKey)
    }
    if (invitationKey) {
      request.setInvitationKey(invitationKey)
    }
    // requestEmailVerificationの呼び出し元の導線毎にキャンペーンのインセンティブ付与のコントロールが必要な場合は別途対応が必要
    if (this.$cookies.get('via_link_with_param')) {
      request.setParameterViaLink(this.$cookies.get('via_link_with_param'))
    }
    await grpcClient({
      method: methodModule.BusinessMailVerificationService.AddVerifyRequest,
      request,
      metadata
    })
    commit('SAVE_EMAIL', email)
  },
  async verifyToken({ commit, rootState }, { token }) {
    const requestModule = await import('~/stub/apigateway/business/business_email_verification_pb')
    const methodModule = await import('~/stub/apigateway/business/business_email_verification_pb_service')
    const metadata = commonMetaData(rootState)
    const request = new requestModule.AddVerifyTokenRequest()
    request.setToken(token)
    const response = await grpcClient({
      method: methodModule.BusinessMailVerificationService.AddVerifyToken,
      request,
      metadata
    })
    commit('SAVE_VERIFY_TOKEN_RESPONSE', response)
  }
}

// mutations
export const mutations = {
  SAVE_EMAIL(state, email) {
    state.email = email
  },
  SAVE_VERIFY_TOKEN_RESPONSE(state, data) {
    Object.assign(state, data)
  },
  SAVE_IS_PRIVATE_VERIFICATION(state, isPrivateVerification) {
    state.isPrivateVerification = isPrivateVerification
  },
  SAVE_IS_SESSION_KEY_REQUIRED(state, isSessionKeyRequiredToResendEmail) {
    state.isSessionKeyRequiredToResendEmail = isSessionKeyRequiredToResendEmail
  }
}
